const FIRST_IMAGE_SELECTOR = '[data-first-image-container]';
const RESTORE_DELAY_SHORT_MS = 400;
const RESTORE_DELAY_LONG_MS = 1000;
const RESTORE_DELAYS_MS = [0, RESTORE_DELAY_SHORT_MS, RESTORE_DELAY_LONG_MS];
const GALLERY_LOCK_DURATION_MS = 1500;

let _authorizedSrc = null;
let _authorizedSrcset = null;

const getImageSrc = (src) => {
  if (!src) return src;
  if (src.startsWith('//')) return window.location.protocol + src;
  if (src.startsWith('/')) return window.location.origin + src;
  return src;
};

const revertUnauthorizedChanges = () => {
  document.querySelectorAll(FIRST_IMAGE_SELECTOR).forEach(container => {
    const img = container.querySelector('img');
    if (!img) return;
    if (_authorizedSrc && img.getAttribute('src') !== _authorizedSrc) {
      img.setAttribute('src', _authorizedSrc);
    }
    if (_authorizedSrcset && img.getAttribute('srcset') !== _authorizedSrcset) {
      img.setAttribute('srcset', _authorizedSrcset);
    }
  });
};

export const initGalleryProtection = () => {
  const firstContainer = document.querySelector(FIRST_IMAGE_SELECTOR);
  if (!firstContainer) return;

  const img = firstContainer.querySelector('img');
  if (!img) return;

  _authorizedSrc = img.getAttribute('src') || '';
  _authorizedSrcset = img.getAttribute('srcset') || '';

  // Observe the swiper wrapper (subtree: true) so Swiper loop-mode clones are covered too.
  // Swiper moves slides via transforms, not src changes, so this stays quiet during normal use.
  const swiperEl = firstContainer.closest('[data-swiper]') || firstContainer.parentElement;

  new MutationObserver(revertUnauthorizedChanges)
    .observe(swiperEl, { attributes: true, attributeFilter: ['src', 'srcset'], subtree: true });

  // Fallback for async app scripts that fire after DOMContentLoaded.
  window.addEventListener('load', () => {
    RESTORE_DELAYS_MS.forEach(ms => setTimeout(revertUnauthorizedChanges, ms));
  }, { once: true });

  // Prevent third-party scripts (e.g. Fast Bundle) from navigating the gallery Swiper
  // on page load by disabling slide movement entirely until the user physically
  // interacts with the gallery or the lock window expires.
  const attachSwiperLock = () => {
    const swiperInstance = swiperEl.swiper;
    if (!swiperInstance) return;

    swiperInstance.allowSlideNext = false;
    swiperInstance.allowSlidePrev = false;

    const unlock = () => {
      swiperInstance.allowSlideNext = true;
      swiperInstance.allowSlidePrev = true;
    };

    swiperEl.addEventListener('touchstart', unlock, { once: true, passive: true });
    swiperEl.addEventListener('mousedown', unlock, { once: true });
    window.addEventListener('load', () => {
      setTimeout(unlock, GALLERY_LOCK_DURATION_MS);
    }, { once: true });
  };

  if (swiperEl.swiper) {
    attachSwiperLock();
  } else {
    setTimeout(attachSwiperLock, 0);
  }
};

const updateProductGallery = (variant) => {
  const firstImageContainers = document.querySelectorAll(FIRST_IMAGE_SELECTOR);
  if (!firstImageContainers.length) return;

  if (!variant || !variant.featured_image || !variant.featured_image.src) return;

  const formattedImageURL = getImageSrc(variant.featured_image.src);

  // Authorize the new src BEFORE mutating any img so the observer allows it
  _authorizedSrc = formattedImageURL;
  _authorizedSrcset = formattedImageURL;

  firstImageContainers.forEach((container) => {
    const imageEl = container.querySelector('img');
    if (imageEl) {
      if (imageEl.getAttribute('src') === formattedImageURL) return;
      imageEl.setAttribute('src', formattedImageURL);
      if (imageEl.hasAttribute('srcset')) imageEl.setAttribute('srcset', formattedImageURL);
      if (variant.featured_image?.alt) imageEl.setAttribute('alt', variant.featured_image.alt);
    }
  });
};

export default updateProductGallery;
